<template>
  <v-card v-if="item">
    <v-container fluid >
      <v-layout row>
        <v-flex xs7>
          <div>
            <div 
              v-if="item.customName || item.displayName"
              class="headline">{{ item.customName?item.customName:item.displayName }}</div>
            <div>
              <v-icon v-if="item.role==='admin'">person</v-icon> 
              <v-icon v-if="item.role==='editor'">person_outline</v-icon> 
              <v-icon v-if="item.role==='viewer'">remove_red_eye</v-icon> 
              {{ $t(`entity.${storeModule}.role.options.${item.role}`) }}
            </div>
          </div>
        </v-flex>
        <v-flex xs5>
          <v-img
            v-if="item.photoURL"
            :src="item.photoURL"
            height="100px"
            contain
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div v-if="item.email">
            <v-icon>contact_mail</v-icon> 
            {{ item.email }}
          </div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div v-if="item.description">
            <v-icon>comment</v-icon> 
            {{ item.description }}
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card-actions light>
      <v-spacer/>
      <template v-if="adminMode">
        <v-menu 
          :key="`menu-${item.id}`"
          open-on-hover 
          top 
          offset-y>
          <v-btn
            slot="activator"
            icon
            flat
            color="warning" >
            <!--<span>{{ $t(`page.matches.options`) }}</span>-->
            <v-icon>more_horiz</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="editItem(item.id)">
              <v-list-tile-title><v-icon>edit</v-icon> {{ $t(`general.edit`) }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile 
              color="red"
              @click="deleteItem">
              <v-list-tile-title><v-icon color="red">delete_forever</v-icon> {{ $t(`general.delete`) }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <BaseFormModal 
          v-if="menuOpen"
          :item="item"
          :entity="entity"
          :model="model"
          :menu-open.sync="menuOpen"
          @onUpdate="onUpdate"/>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import clubUserModel from '@/lib/data/models/clubUser'
import BaseFormModal from '@/components/Base/BaseFormModal'
// const debug = require('debug')('OD::ClubUserCard')

export default {
  name: 'ClubUserCard',
  components: {
    BaseFormModal,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    adminMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      storeModule: 'clubUser',
      entity: 'clubUser',
      menuOpen: false,
    }
  },
  computed: {
    model() {
      return clubUserModel
    },
    displayName() {
      if (this.item) {
        const name = this.item.customName
          ? ` [${this.item.customName}]`
          : this.item.displayName
            ? ` [${this.item.displayName}]`
            : ''
        return this.item.email + name
      }
      return '---'
    },
  },
  methods: {
    editItem(id) {
      this.menuOpen = true
    },
    async deleteItem(id) {
      const page = 'clubUsers'
      const result = await this.$swal({
        title: this.$t(`page.${page}.delete.title`),
        text: this.$t(`page.${page}.delete.text`),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t(`page.${page}.delete.cancelButtonText`),
        confirmButtonText: this.$t(`page.${page}.delete.confirmButtonText`),
      })
      // debug('result', result)
      if (result) {
        this.$emit('onDelete', this.item)
        this.$swal({
          title: this.$t(`page.${page}.delete.confirm.title`),
          text: this.$t(`page.${page}.delete.confirm.text`),
          type: 'success',
          showConfirmButton: false,
          timer: 1500,
        })
      }
    },
    onUpdate(newItem, item) {
      // debug('onUpdate', newItem, item)
      this.$emit('onUpdate', newItem, item)
    },
  },
}
</script>

<style>
</style>
